import { useState } from "react";
import { C } from "../../../constants/theme";
import { Btn } from "../../ui/Btn";

/* Taxas de venda (plataforma, pagamento, comissão, imposto) — % descontado
   do preço de venda, entram corretamente no cálculo (engine.js resolve o
   preço de forma que, depois de tirar essas taxas, sobra exatamente o
   lucro/margem escolhido — nunca soma ingênua). */
export function TaxasSecao({ taxas, adicionar, remover, perfis, aplicarPerfil }) {
  const [nome, setNome] = useState("");
  const [pct, setPct] = useState("");

  const confirmar = () => {
    if (!nome.trim() || !(parseFloat(pct) > 0)) return;
    adicionar(nome.trim(), pct);
    setNome(""); setPct("");
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
      {perfis?.length > 0 && (
        <div>
          <div style={{ color: C.muted, fontSize: 10, fontWeight: 700, letterSpacing: .5, marginBottom: 6 }}>USAR PERFIL SALVO</div>
          <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
            {perfis.map(p => (
              <button key={p.id} onClick={() => aplicarPerfil(p.id)}
                style={{ padding: "5px 12px", borderRadius: 16, fontSize: 11.5, fontWeight: 700, cursor: "pointer", background: "transparent", border: "1px solid " + C.border, color: C.muted }}>
                {p.nome}
              </button>
            ))}
          </div>
        </div>
      )}

      <div style={{ color: C.muted, fontSize: 11, lineHeight: 1.5 }}>
        Vai anunciar em Shopee ou Mercado Livre? Não cadastre a comissão aqui —
        ela tem uma parte fixa em R$ que muda por faixa de preço. Use o
        simulador <strong style={{ color: C.text }}>🛒 Loja online</strong>, que
        já usa a tabela oficial de cada loja.
      </div>

      <div style={{ display: "flex", gap: 8, alignItems: "flex-end" }}>
        <div style={{ flex: 1 }}>
          <input value={nome} onChange={e => setNome(e.target.value)} placeholder="Ex: Comissão da plataforma"
            style={{ width: "100%", boxSizing: "border-box", background: C.panel, border: "1px solid " + C.border, borderRadius: 8, color: C.text, padding: "8px 12px", fontSize: 13, outline: "none" }} />
        </div>
        <input type="number" value={pct} onChange={e => setPct(e.target.value)} placeholder="%"
          style={{ width: 64, background: C.panel, border: "1px solid " + C.border, borderRadius: 8, color: C.text, padding: "8px 10px", fontSize: 13, outline: "none", boxSizing: "border-box" }} />
        <Btn small color="#38bdf8" onClick={confirmar}>➕</Btn>
      </div>

      {taxas.length === 0 && <div style={{ color: C.muted, fontSize: 12 }}>Nenhuma taxa — o preço não desconta nada.</div>}
      {taxas.length > 0 && (
        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          {taxas.map(t => (
            <div key={t.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", background: C.card, borderRadius: 8, padding: "6px 10px" }}>
              <span style={{ color: C.text, fontWeight: 600, fontSize: 12.5 }}>{t.nome}</span>
              <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <span style={{ color: "#38bdf8", fontWeight: 700, fontSize: 12.5 }}>{t.pct}%</span>
                <button onClick={() => remover(t.id)} style={{ background: "none", border: "none", color: C.danger, cursor: "pointer", fontSize: 14, padding: 0 }}>✕</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
